<template>
  <div class="pre-header">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-sm-6 additional-shop-info">
          <!-- <ul class="list-unstyled list-inline">
            <li><i class="fa fa-phone"/><span>+1 456 6717</span></li>
            <li><i class="fa fa-envelope-o"/><span>info@keenthemes.com</span></li>
          </ul> -->
        </div>
        <div class="col-md-6 col-sm-6 additional-nav">
          <ul v-if="!isLogin" class="list-unstyled list-inline pull-right">
            <!--            <li><a href="javascript:void(0)" @click="switchlang"><img src="@/assets/image/en.png" width="16px" height="11px"> English</a></li>-->
            <li><a href="javascript:void(0)" @click="handleFollowUs('https://en.beeftochina.com.cn/BTCInfo')"><img src="@/assets/image/en.png" width="16px" height="11px"> English</a></li>
            <li><a href="javascript:void(0)" @click="openLoginModal">登录</a></li>
            <li><router-link to="/signup">注册</router-link></li>
          </ul>
          <ul v-if="isLogin" class="list-unstyled list-inline pull-right">
            <!--            <li><a href="javascript:void(0)" @click="switchlang"><img src="@/assets/image/en.png" width="16px" height="11px"> English</a></li>-->
            <li><a href="javascript:void(0)" @click="handleFollowUs('https://en.beeftochina.com.cn/BTCInfo')"><img src="@/assets/image/en.png" width="16px" height="11px"> English</a></li>
            <!-- <li v-if="this.$store.getters.isExpire"><router-link :to="{ path: '/charge', query: { isshow: false }}">产品续订</router-link></li> -->
            <li class="user"><router-link to="/account"><img src="@/assets/image/btc_user.png" height="16px"> {{ this.$store.getters.name }} - BTC个人中心</router-link></li>
            <li><a href="javascript:void(0)" @click.prevent="logout">退出</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonmix from '@/utils/commonmix'
// import { removeToken } from '@/utils/auth'
// import { delStore, delLocalStore } from '@/utils/common'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

export default {
  mixins: [commonmix],
  methods: {
    logout() {
      // delStore()
      // removeToken()
      // delLocalStore()
      this.$store.dispatch('clearToken')
      this.$router.replace('/BTCInfo')
    },
    switchlang() {
      locale.use(lang) // 设置element语言
      sessionStorage.lang = 'en'
      this.$i18n.locale = sessionStorage.lang
      this.$router.replace('/english/BTCInfo')
    },
    handleFollowUs(url) {
      location.replace(url)
    }
  }
}
</script>

<style scoped>
.user a{
  color: #317ab4!important;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/PreHeader/index.vue